import { Box, styled } from "@mui/material";

const Item = styled(Box)(({ theme }) => ({
    ...theme.typography.body1,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));

export default Item;